import React from 'react';

import { Autocomplete, TextField } from '@mui/material';

type Props = {
  label: string;
  options: Array<string>;
  value: Array<string>;
  onChange: (value: Array<string>) => void;
};

/** Empty means every value. */
export default function FilterSelect({ label, options, value, onChange }: Props) {
  return (
    <Autocomplete
      multiple
      size="small"
      limitTags={2}
      options={options}
      value={value}
      onChange={(_, next) => onChange(next)}
      renderInput={(params) => <TextField {...params} label={label} placeholder={value.length ? '' : 'All'} />}
      sx={{ minWidth: 200, maxWidth: 320 }}
    />
  );
}
